(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bcp-mobile-clarity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bcp-mobile-summary')) {
    customElements.define('bcp-mobile-summary', class extends HTMLElement {
      connectedCallback() {
        this.initialize = this.initialize || this.setup.bind(this);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
        } else {
          this.setup();
        }
      }
      setup() {
        if (!this.isConnected || this.mediaQuery) return;
        const root = this.closest('[id^="MainProduct-"][data-product-handle="bark-control-pro"]');
        const info = root && root.querySelector('[id^="ProductInfo-"]');
        if (!info) return;
        const nodes = Array.from(info.children).filter(node =>
          node.matches('.product__title, .product__price, .product__tax, .shipping_policy, .payment_terms') ||
          (node.matches('.shopify-app-block') && (node.id.endsWith('__judge_me_reviews_preview_badge_jh6KNK') || node.querySelector('.jdgm-preview-badge')))
        );
        if (!nodes.some(node => node.matches('.product__title')) || !nodes.some(node => node.matches('.product__price'))) return;
        this.items = nodes.map(node => {
          const anchor = document.createTextNode('');
          node.before(anchor);
          return { node, anchor };
        });
        this.mediaQuery = window.matchMedia('(max-width: 576px)');
        this.relocate = () => {
          const focused = document.activeElement;
          const focusIsMoving = this.items.some(({ node }) => node.contains(focused));
          for (const { node, anchor } of this.items) {
            if (this.mediaQuery.matches) {
              if (node.parentNode !== this) this.append(node);
            } else if (anchor.parentNode && anchor.nextSibling !== node) {
              anchor.parentNode.insertBefore(node, anchor.nextSibling);
            }
          }
          if (focusIsMoving && focused.isConnected && document.activeElement !== focused) focused.focus({ preventScroll: true });
        };
        this.mediaQuery.addEventListener('change', this.relocate);
        this.relocate();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.initialize);
        if (this.mediaQuery) {
          this.mediaQuery.removeEventListener('change', this.relocate);
          for (const { node, anchor } of this.items) {
            if (anchor.parentNode && anchor.nextSibling !== node) anchor.parentNode.insertBefore(node, anchor.nextSibling);
            anchor.remove();
          }
          this.mediaQuery = null;
          this.items = [];
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dsm-mobile-clarity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dsm-mobile-summary')) {
    customElements.define('dsm-mobile-summary', class extends HTMLElement {
      connectedCallback() {
        this.initialize = this.initialize || this.setup.bind(this);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
        } else {
          this.setup();
        }
      }
      setup() {
        if (!this.isConnected || this.mediaQuery) return;
        const root = this.closest('[id^="MainProduct-"]');
        const info = root && root.querySelector('[id^="ProductInfo-"]');
        if (!info) return;
        const nodes = Array.from(info.children).filter(node =>
          node.matches('.product__title, .product__price, .product__tax, .shipping_policy, .payment_terms') ||
          (node.matches('.shopify-app-block') && (node.id.endsWith('__judge_me_reviews_preview_badge_jh6KNK') || node.querySelector('.jdgm-preview-badge')))
        );
        if (!nodes.some(node => node.matches('.product__title')) || !nodes.some(node => node.matches('.product__price'))) return;
        this.items = nodes.map(node => {
          const anchor = document.createTextNode('');
          node.before(anchor);
          return { node, anchor };
        });
        this.mediaQuery = window.matchMedia('(max-width: 576px)');
        this.relocate = () => {
          const focused = document.activeElement;
          const focusIsMoving = this.items.some(({ node }) => node.contains(focused));
          for (const { node, anchor } of this.items) {
            if (this.mediaQuery.matches) {
              if (node.parentNode !== this) this.append(node);
            } else if (anchor.parentNode && anchor.nextSibling !== node) {
              anchor.parentNode.insertBefore(node, anchor.nextSibling);
            }
          }
          if (focusIsMoving && focused.isConnected && document.activeElement !== focused) focused.focus({ preventScroll: true });
        };
        this.mediaQuery.addEventListener('change', this.relocate);
        this.relocate();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.initialize);
        if (this.mediaQuery) {
          this.mediaQuery.removeEventListener('change', this.relocate);
          for (const { node, anchor } of this.items) {
            if (anchor.parentNode && anchor.nextSibling !== node) anchor.parentNode.insertBefore(node, anchor.nextSibling);
            anchor.remove();
          }
          this.mediaQuery = null;
          this.items = [];
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
